import { useEffect, useRef, useState } from "react";

export function useGridContainerHeight() {
	const [containerHeight, setContainerHeight] = useState<number>(0);
	const [filtersHeight, setFiltersHeight] = useState<number>(0);

	const containerRef = useRef<HTMLDivElement>(null);
	const filtersRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const updateHeights = () => {
			if (containerRef.current) {
				setContainerHeight(containerRef.current.offsetHeight);
			}
			if (filtersRef.current) {
				setFiltersHeight(filtersRef.current.offsetHeight);
			}
		};

		updateHeights();
		window.addEventListener("resize", updateHeights);
		return () => {
			window.removeEventListener("resize", updateHeights);
		};
	}, [containerRef, filtersRef]);

	return { containerRef, filtersRef, containerHeight, filtersHeight };
}
